import * as Carrom from "carrom-king-engine";

export class GameVars {

    public static gameData: GameData;
    public static scaleY: number;
    public static isDesktop: boolean;
    public static aspectRatio: number;
    public static currentScene: Phaser.Scene;
    public static intitialised: boolean;
    public static paused: boolean;
    public static turnCompleted: boolean;
    public static waintingTurn: boolean;
    public static gameOver: boolean;
    public static onlineMode: boolean;
    public static gameMode: string;
    public static difficulty: string;
    public static playerData: Player;
    public static adversaryData: Player;
    public static winningPlayerId: string;
    public static currentTurnPlayerId: string;
    public static turnsToForceGameOver: number;
    public static playerColor: string;
    public static adversaryColor: string;
    public static reversedBoard: boolean;
    public static tutorialMode: boolean;
    public static playingAgainstBot: boolean;
    public static stake: number;
    public static carromEngine: Carrom.Engine;
    public static pucks: Carrom.Puck [];
    public static prevPucks: Carrom.Puck [];
    public static strikerPosition: Carrom.Vector2D;
    public static queenNeedsToBeCovered: boolean;
    public static time: number;
    public static tutorialCompleted: boolean;
    public static turnData: TurnData;
    public static connection: boolean;
    public static tutorialStage: string;
    public static lastShotReplicated: number;
    public static friction: number = 15;
    public static carromConfig: Carrom.CarromConfig;

    public static needSendTurnData: boolean;
    public static isAdversaryLeftBeforeGame: boolean;    
    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
